<template>
  <div class="menu_home" @mouseleave="groupIndex = -1">
    <!-- <div class="menu_home"> -->
    <div class="menu_content">
      <div class="menu_left flex-shrink">
        <div
          v-for="(items, idx) in categoryList"
          :key="idx"
          class="menu_left_item"
          :class="{ choosedGroup: idx === groupIndex }"
          @mouseover="mouseoverGroup(idx)"
        >
          <div
            class="menu_one ellipsis cursor-pointer"
            v-for="(item, index) in items"
            :key="index"
            @click.stop="jumpj(item.foregroundCategoryId)"
            @mouseover.stop="mouseoverItem(index, idx)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="menu_right flex-grow" v-show="groupIndex > -1">
        <!-- <div class="menu_right flex-grow"> -->
        <!-- 一级类目组 -->
        <div class="menu_one_row flex-shrink">
          <div
            class="menu_one_title cursor-pointer"
            :class="{ menu_one_title_choosed: groupItemIndex === index }"
            v-for="(item, index) in groupIndex > -1 ? categoryList[groupIndex] : []"
            :key="item.foregroundCategoryId"
            @click.stop="jumpj(item.foregroundCategoryId)"
            @mouseover="groupItemIndex = index"
          >
            {{ item.name }}
          </div>
        </div>
        <!-- 显示对应二级三级 -->
        <div class="menu_one_content flex-grow" v-show="groupItemIndex > -1">
          <div
            class="menu_two_row"
            v-for="(twoItem, twoIndex) in groupIndex > -1 && groupItemIndex > -1
              ? categoryList[groupIndex][groupItemIndex].children || []
              : []"
            :key="twoItem.foregroundCategoryId"
          >
            <div
              class="two_menu_name cursor-pointer"
              @click.stop="jumpj(twoItem.foregroundCategoryId)"
            >
              {{ twoItem.name }}
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="three_menu">
              <span
                class="three_menu_name cursor-pointer"
                @click.stop="jumpj(threeItem.foregroundCategoryId)"
                v-for="threeItem in categoryList[groupIndex][groupItemIndex].children[
                  twoIndex
                ].children || []"
                :key="threeItem.foregroundCategoryId"
                >{{ threeItem.name }}</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      categoryList: [], // 产品类目
      groupIndex: -1, // 悬停组别的索引
      groupItemIndex: -1, // 悬停组别中类目的索引
    };
  },
  created() {
    this.getCategoryList();
  },
  methods: {
    // 产品分类hover事件
    mouseoverItem(index, idx) {
      console.log("mouseoverItem");

      this.groupItemIndex = index;
      this.$set(this.cacheGroupIndex, idx, index);
      this.groupIndex = idx;
    },
    // 产品分类行hover事件
    mouseoverGroup(idx) {
      console.log("mouseoverGroup");
      if (this.groupIndex !== idx) {
        this.groupItemIndex = this.cacheGroupIndex[idx] || 0;
      }
      this.groupIndex = idx;
    },
    jumpj(id) {
      let jumpName = "goodCategoryList";
      if (this.menuTypes === "selectionInquiry") {
        jumpName = "selectionCategoryList";
      }
      this.$router.push({
        name: jumpName,
        query: {
          foregroundCategoryId: id,
          brandIdList: "",
          seriesIdList: "",
          attributeValueIdList: "",
          salesDesc: false,
          priceDesc: false,
          popularityDesc: false,
          category: true,
        },
      });
    },
    // 获取分类列表
    getCategoryList() {
      this.cacheGroupIndex = {};
      // 产品分类
      let httpUrl = "/front/cross/commodity-user/app/category-list";
      // 选型分类
      if (this.menuTypes === "selectionInquiry") {
        httpUrl = "/front/cross/commodity-user/app/category-list?spuType=lectotype";
      }
      this.$http
        .get(httpUrl)
        .then(({ data: res }) => {
          let categoryList = [];
          if (res.data.foregroundCategoryList && res.data.foregroundCategoryList.length) {
            for (let i = 0; i < res.data.foregroundCategoryList.length; i += 2) {
              categoryList.push(res.data.foregroundCategoryList.slice(i, i + 2));
            }
          }
          this.categoryList = categoryList;
          console.log(this.categoryList);

          this.allmenuList = res.data.foregroundCategoryList.splice(0, 12) || [];
          this.$store.commit(
            "setCategoryMenuList",
            res.data.foregroundCategoryList || []
          );
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.menu_home {
  display: inline-block;
  width: 250px;
  height: 320px;
  font-family: Alibaba PuHuiTi;
  .menu_content {
    width: 1190px;
    display: flex;
    margin: 0 auto;
    height: 320px;
    .menu_left {
      width: 235px;
      height: 100%;
      z-index: 11;
      color: black;
      overflow-y: auto;
      padding: 10px 0;
      background: #fff;
      border-radius: 16px;
      border: 2px solid #f5f6fa;
      // padding: 0 20px;
      .menu_left_item {
        line-height: 40px;
        padding: 0 20px;

        // border-bottom: 1px solid #eee;
        // background: url("~@/assets/img/more.jpg") no-repeat right;
        .menu_one {
          color: #666;
          font-size: 14px;
          padding-right: 10px;
          display: inline-block;
          vertical-align: top;
          // overflow: hidden;
          max-width: 50%;

          // height: 40px;
          &:hover {
            color: #2a54d1;
          }
        }
      }

      .choosedGroup {
        background: rgba($color: #2a54d1, $alpha: 0.1);
      }
    }

    .menu_right {
      background-color: #fff;
      z-index: 11;
      display: flex;
      flex-direction: column;
      height: 320px;

      .menu_one_row {
        width: 100%;
        height: 45px;
        background: #fff;
        border-bottom: 2px solid #f6f5fa;
        .menu_one_title {
          display: inline-block;
          color: #333;
          font-size: 16px;
          font-weight: bold;
          text-align: center;
          line-height: 42px;
          padding: 0px 20px;
          width: max-content;
        }

        .menu_one_title_choosed {
          background: #fff;
          color: #2a54d1;
        }
      }

      .menu_one_content {
        overflow-y: auto;

        .menu_two_row {
          padding: 0 30px;
          border-bottom: 2px solid #f6f5fa;
        }
        .two_menu_name {
          margin-top: 10px;
          line-height: 30px;
          font-size: 14px;
          font-weight: 500;
          color: #333;
          &:hover {
            color: #2a54d1;
            opacity: 0.9;
          }
        }

        .three_menu {
          font-size: 12px;
          font-weight: 400;
          color: #666;
          line-height: 25px;

          .three_menu_name {
            margin-right: 16px;
            &:hover {
              color: #2a54d1;
              opacity: 0.9;
            }
          }
        }
      }
    }
  }
}
</style>
